import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export const useBranch = () => {
  const location = useLocation();

  const branch = useMemo(() => {
    return location.pathname.split("/")[2] || "";
  }, [location.pathname]);

  return branch;
};